module.exports = __webpack_public_path__ + "media/images/lave-vaisselle-1734b05d3e479c546206ced77f5cba59.svg";